import React, { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { getAllUser, deleteUser } from "../../redux/apiCall/userCall";
import swal from "sweetalert";
import "../pages/Styles/Admin.css";

const TableUser = () => {
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this user!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(deleteUser(id)).then(() => {
          dispatch(getAllUser());
        });
      }
    });
  };

  const columns = [
    { field: "_id", headerName: "ID", width: 70 },
    { field: "firstName", headerName: "First Name", width: 110 },
    { field: "lastName", headerName: "LastName", width: 150 },
    { field: "email", headerName: "email", width: 150 },
    { field: "username", headerName: "username", width: 150 },
    { field: "phone", headerName: "Number", width: 110 },
    {
      field: "image",
      headerName: "Image",
      width: 120,
      align: "center",
      headerAlign: "center",
      cellClassName: "admin-table-image-column",
      renderCell: (params) => (
        <div className="admin-table-image-cell">
          <img
            className="admin-table-image"
            src={params.row.userImage}
            width={80}
            height={80}
            alt="user avatar"
          />
        </div>
      ),
    },
    {
      field: "Action",
      headerName: "Action",
      sortable: false,
      width: 120,
      renderCell: (params) => (
        <button
          className="btn btn-danger btn-sm admin-btn-delete"
          onClick={() => handleDelete(params.row._id)}
        >
          Delete
        </button>
      ),
    },
  ];

  const rows = users.map((user) => ({
    ...user,
    id: user._id,
  }));

  return (
    <div className="admin-table-wrapper">
      <DataGrid rows={rows} columns={columns} pageSize={5} rowHeight={100} />
    </div>
  );
};

export default TableUser;
